import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../src/lib/component-base';

const planeImageOrange = require('../../../../../../../static/images/plane-orange.svg');
const planeImageWhite = require('../../../../../../../static/images/plane-white.svg');

@componentBase('RouteTabComponent')
export default class RouteTabComponent extends React.Component {
  static propTypes = {
    departureFS: PropTypes.string,
    departureCity: PropTypes.string,
    arrivalFS: PropTypes.string,
    arrivalCity: PropTypes.string,
    small: PropTypes.bool,
    last: PropTypes.bool,
    index: PropTypes.number,
    className: PropTypes.string,
    unselected: PropTypes.bool,
  };

  static defaultProps = {
    departureFS: null,
    departureCity: null,
    arrivalFS: null,
    arrivalCity: null,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      divStyle: {
        minWidth: '150px',
        display: 'inline-block',
      },
      textDivStyle: {
        padding: '5px 2px 0',
        margin: '5px 5px 0',
        display: 'inline-block',
        top: '0',
        position: 'relative',
        textAlign: 'center',
      },
      fsTextStyle: {
        fontSize: '25px',
        margin: '0',
        display: 'inline-block',
      },
      iconStyle: {
        display: 'inline-block',
        width: '38px',
        height: '100%',
        pointerEvents: 'none',
        maxHeight: '38px',
      },
      iconDivStyle: {
        display: 'inline-block',
        minWidth: '38px',
        maxHeight: '38px',
      },
      infoText: {
        fontSize: '10pt',
        color: 'rgba(255,255,255,0.7)',
        margin: '0',
        textAlign: 'center',
      },
    };
  }

  render() {
    if (this.props.small) {
      this.muiDefaultProps.divStyle = Object.assign(
        this.muiDefaultProps.divStyle,
        {
          minWidth: '100px',
          top: '0',
          position: 'relative',
          padding: '10px',
          paddingBottom: '7px',
        },
      );
      this.muiDefaultProps.textDivStyle = Object.assign(
        this.muiDefaultProps.textDivStyle,
        {
          maxHeight: '18px',
          padding: '0',
          verticalAlign: 'top',
          marginTop: '3px',
        },
      );
      this.muiDefaultProps.fsTextStyle = Object.assign(
        this.muiDefaultProps.fsTextStyle,
        {
          fontSize: '18px',
        },
      );
      this.muiDefaultProps.iconStyle = Object.assign(
        this.muiDefaultProps.iconStyle,
        {
          margin: '0',
          top: '3px',
          minWidth: '38px',
          maxHeight: '20px',
        },
      );
      this.muiDefaultProps.iconDivStyle = Object.assign(
        this.muiDefaultProps.iconDivStyle,
        {
          minWidth: '20px',
        },
      );

      if (!this.props.last) {
        this.muiDefaultProps.divStyle = Object.assign(
          this.muiDefaultProps.divStyle,
          { borderRight: '1px solid #ffffff' },
        );
      }
    } else {
      this.departureCityElement = (<p style={this.muiDefaultProps.infoText}>{this.props.departureCity}</p>);
      this.arrivalCityElement = (<p style={this.muiDefaultProps.infoText}>{this.props.arrivalCity}</p>);
    }

    if (this.props.index === -1) {
      this.muiDefaultProps.divStyle = Object.assign(this.muiDefaultProps.divStyle, { paddingLeft: '13px' });
    }

    return (
      <div style={this.muiDefaultProps.divStyle} className={this.props.className}>
        <div style={this.muiDefaultProps.textDivStyle}>
          <p style={this.muiDefaultProps.fsTextStyle}>{this.props.departureFS}</p>
          {this.departureCityElement}
        </div>
        <div style={this.muiDefaultProps.iconDivStyle}>
          <object key={this.props.unselected ? `route-tab-white-${this.props.index}` : `route-tab-orange-${this.props.index}`} data={this.props.unselected ? planeImageWhite : planeImageOrange} type='image/svg+xml' style={this.muiDefaultProps.iconStyle} />
        </div>
        <div style={this.muiDefaultProps.textDivStyle}>
          <p style={this.muiDefaultProps.fsTextStyle}>{this.props.arrivalFS}</p>
          {this.arrivalCityElement}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/RouteTabComponent.js